import _ from 'lodash';
import { parseZvaMinutesCode } from '@/plans/ZOOM_PHONE$AICONCIERGE/helper/parse';

/**
 * Post-process ZVA plan list before submit payload.
 *
 * For prepaid minute tiers, UI uses a decorated plan_code like "<base>$<minutes>".
 * Backend expects:
 * - planCode: <base>
 * - quantity: <minutes>
 */
export default (planList) => {
  planList.forEach((item) => {
    const { plan_code, minutes } = parseZvaMinutesCode(item?.plan_code);
    if (!minutes) return;

    item.plan_code = plan_code;
    item.cartInfo = item.cartInfo || {};
    item.cartInfo.selected_number = _.toInteger(minutes);
  });
};

